import { instance } from "api/apiBase";

interface MhvillageStatusResponse {
  connected: boolean;
  parsing_email?: string;
}

const BASE_ENDPOINT_URL = "/portal/v1/external_integrations/mhvillage";

export const mhvillageApi = {
  getStatus: async (): Promise<MhvillageStatusResponse> => {
    const { data } =
      await instance.get<MhvillageStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  },

  connect: async (): Promise<MhvillageStatusResponse> => {
    const { data } =
      await instance.post<MhvillageStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  },

  disconnect: async (): Promise<MhvillageStatusResponse> => {
    const { data } =
      await instance.delete<MhvillageStatusResponse>(BASE_ENDPOINT_URL);
    return data;
  }
};
